import organizationsReducer from "./organizationsSlice";
import organizationReducer from "./organizationSlice";

const organizations = {
  organizations: organizationsReducer,
  organization: organizationReducer,
};

export default organizations;
